module.exports = __webpack_public_path__ + "static/media/snellen.be3174e7.jpg";